import React from 'react'
import {StepsProps} from './types'
import resolveProps from '../../utils/resolveProps'

const config = {
  types: [
    {
      title: 'default',
      isDefault: true
    },
    'darkest'
  ],
  modifiers: ['xs', 'sm', 'md', 'lg', 'scroll'],
  states: []
}
const renderListStep = (steps, props) => {
  const list = steps.map((value, index) => (
    <li
      key={index}
      className={
        `mdn-Steps-list-item mdn-Steps-list-item--${value.status}` +
        (value.status === 'disabled' ? 'mdn-Steps-list-item--disabled' : '')
      }
    >
      <p
        className={
          'mdn-Steps-text mdn-Heading ' +
          (props.inverse || props.darkest ? 'mdn-Heading--inverse' : '')
        }
      >
        {value.title}
      </p>
    </li>
  ))
  return list
}

export default function Steps(props:StepsProps) {
  const { data, inverse, dataSteps, xs, sm, md, lg, scroll, darkest, ...rest } = props
  return (
    <div {...rest} className={resolveProps(props, config, 'Steps')}>
      <ul className="mdn-Steps-list">
        {renderListStep(data || dataSteps, props)}
      </ul>
    </div>
  )
}
